// Mobile menu close on outside click
document.addEventListener('click', function(e) {
  const menu = document.querySelector('.mobile-menu');
  if (menu && menu.classList.contains('open') && !menu.contains(e.target) && !e.target.closest('.nav-hamburger')) {
    menu.classList.remove('open');
  }
});

// Add to cart via Shopify AJAX API
async function addToCart(variantId, quantity = 1) {
  if (!variantId) { console.warn('addToCart: variantId missing'); return; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 })
    });
    const data = await res.json();
    if (!res.ok) {
      console.error('Cart add error:', data.description || data.message);
      showCartNotification('Error al agregar al carrito');
      return;
    }
    updateCartCount();
    showCartNotification(data.title || 'Producto');
    // Open drawer — fetchAndRenderCart may not be defined yet on page load races
    if (typeof openCartDrawer === 'function') {
      if (typeof fetchAndRenderCart === 'function') await fetchAndRenderCart();
      openCartDrawer();
    }
  } catch (err) {
    console.error('Error adding to cart:', err);
  }
}

// Update cart count badge in nav
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-badge').forEach(el => {
      const prev = parseInt(el.textContent) || 0;
      if (cart.item_count > 0) {
        el.textContent = cart.item_count;
        el.style.display = '';
        if (cart.item_count !== prev) {
          el.classList.remove('bump');
          void el.offsetWidth; // reflow to restart animation
          el.classList.add('bump');
          el.addEventListener('animationend', () => el.classList.remove('bump'), { once: true });
        }
      } else {
        el.style.display = 'none';
      }
    });
    // legacy support for plain .cart-count spans
    document.querySelectorAll('.cart-count:not(.cart-badge)').forEach(el => {
      el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    });
  } catch (err) {}
}

// Toast notification — animated enter + exit
let activeToast = null;

function showCartNotification(title) {
  // Dismiss any existing toast immediately
  if (activeToast) {
    activeToast.remove();
    activeToast = null;
  }

  const toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = `<span class="cart-toast-check" aria-hidden="true">✓</span><span><strong>${title}</strong> agregado al carrito</span>`;
  document.body.appendChild(toast);
  activeToast = toast;

  // Trigger enter animation on next frame
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.classList.add('cart-toast--visible');
    });
  });

  // Exit after 3s
  const timer = setTimeout(() => dismissToast(toast), 3000);

  // Allow tap to dismiss early
  toast.addEventListener('click', () => {
    clearTimeout(timer);
    dismissToast(toast);
  });
}

function dismissToast(toast) {
  if (!toast.parentNode) return;
  toast.classList.remove('cart-toast--visible');
  toast.classList.add('cart-toast--exit');
  toast.addEventListener('transitionend', () => {
    toast.remove();
    if (activeToast === toast) activeToast = null;
  }, { once: true });
}

// Init cart count on load
updateCartCount();

// ── SCROLL REVEALS ──
function initScrollReveals() {
  // Staggered groups — each child gets --stagger index
  const staggerGroups = [
    // Homepage sections
    '.colecciones-grid .coleccion-card',
    '.process-grid .process-step',
    '.products-grid .product-card',
    '.section-header',
    '.cta-section .section-title, .cta-section p, .cta-section .cta-btns, .cta-section .cta-logo',
    // Template grids
    '.collection-products-grid .product-card',
    '.colecciones-grid-page .coleccion-card',
    '.duracion-cards .duracion-card',
    '.cuidado-lista .cuidado-item',
    '.aplicar-steps .aplicar-step',
    '.faq-lista .faq-item',
    '.info-block',
    '.testimonios-grid .testimonio-card',
    '.presson-benefits .benefit-item',
    '.cart-items .cart-item',
    '.product-variants .variant-btn',
  ];

  staggerGroups.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el, i) => {
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
        el.style.setProperty('--stagger', i);
      }
    });
  });

  // Single-element reveals (no stagger)
  const singleReveals = [
    '.catalog-hero-content',
    '.info-page-hero',
    '.product-gallery-main',
    '.cart-summary',
    '.contacto-hero',
    '.coleccion-hero-content',
  ];

  singleReveals.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
        el.style.setProperty('--stagger', 0);
      }
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
  );

  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveals);
} else {
  initScrollReveals();
}

// ── FORMAT MONEY ──
function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  return `$${amount} MXN`;
}

// ── CART DRAWER ──
function openCartDrawer(e) {
  if (e) e.preventDefault();
  fetchAndRenderCart();
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartDrawerBackdrop');
  if (!drawer || !backdrop) return;
  drawer.classList.add('open');
  backdrop.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartDrawerBackdrop');
  if (!drawer || !backdrop) return;
  drawer.classList.remove('open');
  backdrop.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

async function fetchAndRenderCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('drawerItems');
  const totalEl = document.getElementById('drawerTotal');
  const countEl = document.getElementById('drawerCount');
  if (!itemsEl) return;

  if (countEl) {
    countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
  }

  if (totalEl) {
    totalEl.innerHTML = `<span>${formatMoney(cart.total_price)}</span>`;
  }

  // Update badge with bump
  document.querySelectorAll('.cart-badge').forEach(el => {
    const prev = parseInt(el.textContent) || 0;
    if (cart.item_count > 0) {
      el.textContent = cart.item_count;
      el.style.display = '';
      if (cart.item_count !== prev) {
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
        el.addEventListener('animationend', () => el.classList.remove('bump'), { once: true });
      }
    } else {
      el.style.display = 'none';
    }
  });

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '';
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="drawer-item" id="drawer-item-${item.key.replace(/:/g,'-')}">
      <div class="drawer-item-img">
        ${item.image
          ? `<img src="${item.image}" alt="${item.title}" loading="lazy">`
          : `<div style="width:100%;height:100%;background:linear-gradient(150deg,#FCE8F0,#F2B8D0);"></div>`}
      </div>
      <div>
        <div class="drawer-item-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
        <div class="drawer-item-price">${formatMoney(item.final_price)}</div>
        <div class="drawer-item-controls">
          <div class="qty-control">
            <button onclick="drawerUpdateItem('${item.key}', ${item.quantity - 1})" aria-label="Reducir cantidad">−</button>
            <span>${item.quantity}</span>
            <button onclick="drawerUpdateItem('${item.key}', ${item.quantity + 1})" aria-label="Aumentar cantidad">+</button>
          </div>
          <button class="drawer-item-remove" onclick="drawerUpdateItem('${item.key}', 0)" aria-label="Eliminar ${item.product_title}">Eliminar</button>
        </div>
      </div>
    </div>
  `).join('');
}

async function drawerUpdateItem(key, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderCartDrawer(cart);
    const countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(el => {
      el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
    });
  } catch (err) {
    console.error('Error updating cart:', err);
  }
}

// ESC key closes drawer and quick-view
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeCartDrawer();
    closeQuickView();
  }
});

// ── QUICK VIEW ──
function openQuickView(productHandle) {
  const modal = document.getElementById('quickViewModal');
  const body = document.getElementById('quickViewBody');
  if (!modal || !body) return;
  body.innerHTML = '<div class="qv-loading"><div class="qv-spinner"></div></div>';
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  fetch(`/products/${productHandle}.js`)
    .then(r => r.json())
    .then(product => {
      const img = product.images[0]
        ? `<img src="${product.images[0]}" alt="${product.title}" loading="lazy">`
        : `<div style="width:100%;height:100%;background:linear-gradient(150deg,#FCE8F0,#F2B8D0);"></div>`;
      const firstVariant = product.variants[0];
      body.innerHTML = `
        <div class="qv-grid">
          <div class="qv-img">${img}</div>
          <div class="qv-info">
            <div class="qv-title">${product.title}</div>
            <div class="qv-price">${formatMoney(firstVariant.price)}</div>
            <p class="qv-desc">${product.description ? product.description.replace(/<[^>]+>/g,'').slice(0,200) + '…' : ''}</p>
            <button class="btn-add-nest" style="align-self:flex-start;" onclick="addToCart(${firstVariant.id}, 1); closeQuickView();">
              <span class="btn-add-text">Agregar al carrito</span>
              <span class="btn-add-icon" aria-hidden="true">+</span>
            </button>
            <a href="/products/${product.handle}" class="qv-link">Ver producto completo →</a>
          </div>
        </div>`;
    })
    .catch(() => {
      body.innerHTML = '<p style="text-align:center;padding:2rem;color:#7A6268;">No se pudo cargar el producto.</p>';
    });
}

function closeQuickView() {
  const modal = document.getElementById('quickViewModal');
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// ── TESTIMONIAL SWIPE ──
function initSliderSwipe() {
  const sliders = document.querySelectorAll('.testimonios-slider, .slider-track');
  sliders.forEach(slider => {
    let startX = 0;
    let scrollStart = 0;
    let isDragging = false;

    slider.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      scrollStart = slider.scrollLeft;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchmove', e => {
      if (!isDragging) return;
      const dx = startX - e.touches[0].clientX;
      slider.scrollLeft = scrollStart + dx;
    }, { passive: true });

    slider.addEventListener('touchend', () => { isDragging = false; });

    // Mouse drag support
    slider.addEventListener('mousedown', e => {
      startX = e.clientX;
      scrollStart = slider.scrollLeft;
      isDragging = true;
      slider.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', e => {
      if (!isDragging) return;
      const dx = startX - e.clientX;
      slider.scrollLeft = scrollStart + dx;
    });

    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      slider.style.cursor = '';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliderSwipe);
} else {
  initSliderSwipe();
}
